
/* eslint-disable class-methods-use-this */
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { SessionUser } from '@/core/types/session-user';
import myDashboardSVG from '@/assets/images/MyDashboard.svg';
import { SessionService } from '@/core/services/session';

const coreNamespace = namespace('core');

@Component
export default class LoanTopbar extends Vue {
	@Prop({ default: myDashboardSVG })
	logo!: string;

	@coreNamespace.Getter('user')
	public user!: SessionUser;

	get userName(): string {
		return this.user?.name ?? '';
	}

	public logout(): void {
		SessionService.logout();
	}
}

